var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"circle-charts-page"},[_c('div',{ref:"circleCharts",staticClass:"charts"})])
}
var staticRenderFns = []

export { render, staticRenderFns }